// Multilingual dictionary — DE/FR/IT/EN are ALL fully populated.
// No key may be missing in any language (missing keys would surface as a
// German fallback = language mixing, which is not allowed).

const de = {
  app: { name: "Visibilis Control OS", env_production: "PROD", env_preview: "VORSCHAU", env_test: "TEST", env_dev: "DEV", env_unknown: "Umgebung unbekannt" },
  nav: {
    overview: "Übersicht", both_apps: "Apps & Verwaltung", members: "Mitglieder", reviews: "Profilprüfungen",
    activities: "Aktivitäten", groups: "Kreise & Gruppen", reports: "Meldungen & Sicherheit", community: "Community-Beiträge",
    organizations: "Organisationen", support: "Support", content: "Inhalte & Freigaben",
    notifications: "Benachrichtigungen", pilot: "Pilot & Auswertung", audit: "Audit-Log",
    system: "Systemstatus", settings: "Einstellungen", tasks: "Meine Aufgaben", team: "Team & Rechte", help: "Hilfe",
  },
  common: {
    search: "Suchen", filter: "Filter", all: "Alle", status: "Status", actions: "Aktionen",
    approve: "Genehmigen", reject: "Ablehnen", details: "Details", logout: "Abmelden",
    role: "Rolle", language: "Sprache", loading: "Wird geladen …", no_data: "Keine Einträge vorhanden.",
    open_menu: "Menü öffnen", skip_to_content: "Zum Inhalt springen", in_preparation: "In Vorbereitung",
    mark_in_progress: "In Bearbeitung", mark_resolved: "Als gelöst markieren", view_all: "Alle anzeigen",
    reset: "Zurücksetzen", back: "Zurück", save: "Speichern", cancel: "Abbrechen", close: "Schliessen",
  },
  labels: {
    aktiv: "aktiv", ausstehend: "ausstehend", gesperrt: "gesperrt", offen: "offen",
    genehmigt: "genehmigt", abgelehnt: "abgelehnt", freigegeben: "freigegeben",
    "in Bearbeitung": "in Bearbeitung", "gelöst": "gelöst", verifiziert: "verifiziert",
    kritisch: "kritisch", mittel: "mittel", niedrig: "niedrig", ruhend: "ruhend",
  },
  login: {
    title: "Anmeldung", subtitle: "Geschützter Zugang für berechtigte Teammitglieder.",
    email: "E-Mail-Adresse", password: "Passwort", submit: "Weiter",
    twofa_title: "Zwei-Faktor-Authentifizierung",
    twofa_subtitle: "Bitte den 6-stelligen Code aus deiner Authenticator-App eingeben.",
    twofa_submit: "Anmelden", back: "Zurück",
    no_public: "Keine öffentliche Registrierung. Zugang nur für internes Team.",
    preview_hint: "Preview-Hinweis: aktueller Demo-Code", preview_fill: "Code übernehmen",
    error_credentials: "E-Mail oder Passwort ist nicht korrekt.",
    setup_title: "Zwei-Faktor-Authentifizierung einrichten",
    setup_subtitle: "Scanne den QR-Code mit einer Authenticator-App (z. B. Google Authenticator) und gib danach den angezeigten 6-stelligen Code ein.",
    setup_secret_label: "Manueller Schlüssel (falls QR nicht scannbar)",
    setup_scan_hint: "QR-Code mit der App scannen", setup_confirm: "Einrichtung abschließen",
    lost_authenticator: "Authenticator verloren?",
    recover_title: "Mit Wiederherstellungscode anmelden",
    recover_subtitle: "Gib einen deiner einmaligen Wiederherstellungscodes ein. Anschliessend richtest du einen neuen Authenticator ein.",
    recover_code_label: "Wiederherstellungscode",
    recover_submit: "Weiter zur Neu-Einrichtung",
    recover_no_codes: "Keine Wiederherstellungscodes mehr? Teammitglieder wenden sich an den Super Admin, der im Team „2FA neu einrichten“ auslösen kann. Für den Super Admin gilt der dokumentierte Betreiberweg. Danach erscheint beim nächsten Anmelden ein neuer QR-Code.",
    setup_incomplete: "Die Neu-Einrichtung deines Authenticators ist noch nicht abgeschlossen. Über „Authenticator verloren?“ erhältst du mit demselben Wiederherstellungscode einen neuen QR-Code.",
    resume_setup: "QR-Code erneut anzeigen",
    resume_setup_hint: "Deine 2FA-Einrichtung ist noch nicht abgeschlossen. Solange die Einrichtungssitzung gültig ist (5 Minuten), kannst du den QR-Code erneut anzeigen.",
    setup_expired: "Bitte erneut anmelden.",
    session_expired: "Die Anmeldesitzung ist abgelaufen oder wurde beendet (sie gilt 5 Minuten). Bitte erneut mit E-Mail und Passwort anmelden.",
    twofa_qr_hint: "Den QR-Code brauchst du nach der Einrichtung nicht mehr. Ist die Authenticator-App noch auf deinem Gerät, gib einfach den aktuellen 6-stelligen Code daraus ein. Nur wenn App oder Gerät fehlen, wähle „Authenticator verloren?“.",
    recover_back_to_code: "Authenticator doch vorhanden? Zurück zur Code-Eingabe",
    no_codes: {
      title: "Kein Wiederherstellungscode mehr?",
      team: "Teammitglieder: Der Super Admin löst unter Einstellungen → Team „2FA neu einrichten“ aus. Danach erscheint beim nächsten Anmelden ein neuer QR-Code.",
      owner: "Super Admin (Inhaber): Eine Freigabe nur mit Passwort oder E-Mail gibt es nicht. Nötig ist der einmalige Betreiberweg (Runbook „2FA-Wiederherstellung im Control OS“, Weg E):",
      owner_step_1: "Der Betreiber setzt in der Produktion den Secret-Wert SUPER_ADMIN_RECOVERY_TOKEN und veröffentlicht neu. RECOVERY_CODE_PEPPER muss dort ebenfalls wirksam sein, sonst lässt sich die Neu-Einrichtung nicht abschliessen.",
      owner_step_2: "Einmalig POST /api/internal/recovery/super-admin-totp mit dem Header X-Recovery-Token gegen die Produktions-URL aufrufen. Der Wert gehört nie in Chat, E-Mail oder Logs.",
      owner_step_3: "Danach hier mit E-Mail und Passwort anmelden, den neuen QR-Code scannen, den 6-stelligen Code bestätigen und die neuen Wiederherstellungscodes sicher ablegen.",
      owner_step_4: "Den Secret-Wert anschliessend entfernen oder ersetzen und erneut veröffentlichen.",
      honest: "Diese Seite kann den Betreiberschritt nicht auslösen und meldet keinen Erfolg, bevor er ausgeführt ist. Ob der Secret-Wert in der Produktion gesetzt ist, ist hier nicht sichtbar.",
    },
    mail_recovery: {
      title: "Ohne Wiederherstellungscode",
      loading: "Status wird geladen",
      intro: "Du kannst eine Wiederherstellung per E-Mail beantragen. Das ist ein Antrag, keine sofortige Freischaltung: Du bestätigst den Link in der E-Mail, danach gilt eine Wartezeit von {hours} Stunden, und eine unabhängige Freigabe ist nötig. Erst dann erscheint nach erneuter Anmeldung ein neuer QR-Code.",
      request: "Wiederherstellung per E-Mail beantragen",
      mail_missing: "Der E-Mail-Versand ist noch nicht eingerichtet. Ein Antrag ist deshalb im Moment nicht möglich.",
      mail_handed_over: "Die E-Mail wurde an den Versanddienst übergeben. Ob sie ankommt, können wir nicht sehen. Prüfe auch den Spam-Ordner.",
      email_open: "Bestätige den Link in der E-Mail bis {time}. Danach verfällt der Antrag.",
      warning_pending: "Die Bestätigung wird verarbeitet: Die Warn-Mail wird gerade an den Versanddienst übergeben. Erst danach beginnt die Wartezeit.",
      waiting: "Die Wartezeit läuft bis {time}.",
      waiting_done: "Die Wartezeit ist abgelaufen.",
      approval_super_admin: "Die Freigabe durch den Super Admin steht noch aus.",
      approval_operator: "Die Freigabe über den Betreiberweg steht noch aus.",
      approved: "Die Freigabe ist erteilt.",
      operator_missing: "Gesperrt: Der Vertrauensanker des Betreibers ist nicht eingerichtet. Der Antrag bleibt gesperrt, bis der Betreiber diesen Schritt ausführt.",
      operator_step: "Betreiber-Schritt: In der Produktion SUPER_ADMIN_RECOVERY_TOKEN im Secret Store setzen und neu veröffentlichen. Danach Antrag {id} mit POST /api/internal/recovery/2fa-email-request/approve (Header X-Recovery-Token) freigeben. Ablauf im Runbook.",
      ready: "Alle Bedingungen sind erfüllt. Du kannst jetzt einen neuen Authenticator einrichten.",
      complete: "Neuen QR-Code einrichten",
      cancel: "Antrag abbrechen",
      cancelled: "Der Antrag wurde abgebrochen.",
      expires: "Der Antrag verfällt spätestens am {time}.",
      closed: {
        abgeschlossen: "Dein letzter Antrag ist abgeschlossen.",
        abgebrochen: "Dein letzter Antrag wurde abgebrochen.",
        abgelehnt: "Dein letzter Antrag wurde abgelehnt.",
        abgelaufen: "Dein letzter Antrag ist abgelaufen.",
        versand_fehlgeschlagen: "Für deinen letzten Antrag konnte die E-Mail nicht an den Versanddienst übergeben werden. Es wurde nichts aktiviert.",
        warnung_fehlgeschlagen: "Für deinen letzten Antrag konnte die Warn-Mail nicht übergeben werden. Der Antrag wurde beendet, es wurde nichts aktiviert.",
        "ungültig": "Dein letzter Antrag ist ungültig geworden, weil das Konto inzwischen geändert wurde.",
      },
      link_title: "2FA-Wiederherstellung",
      link_confirm_intro: "Bestätige hier deinen Antrag auf Wiederherstellung der Zwei-Faktor-Anmeldung. Danach beginnt die Wartezeit von 24 Stunden.",
      link_cancel_intro: "Brich hier den Antrag auf Wiederherstellung ab. Das gilt sofort.",
      link_confirm: "Antrag bestätigen",
      link_cancel: "Antrag jetzt abbrechen",
      link_invalid: "Dieser Link ist nicht gültig oder abgelaufen.",
      link_confirmed: "Antrag bestätigt. Die Wartezeit läuft bis {time}.",
      link_next_super_admin: "Danach muss der Super Admin den Antrag freigeben. Anschliessend meldest du dich erneut an und wählst „Authenticator verloren?“.",
      link_next_operator: "Danach ist eine Freigabe über den Betreiberweg nötig. Anschliessend meldest du dich erneut an und wählst „Authenticator verloren?“.",
      link_warning_sent: "Eine Warn-Mail mit Abbruch-Link wurde an den Versanddienst übergeben.",
      link_warning_failed: "Die Warn-Mail konnte nicht an den Versanddienst übergeben werden. Der Antrag läuft trotzdem; du kannst ihn bei der Anmeldung abbrechen.",
      link_cancelled: "Der Antrag ist abgebrochen. Falls du ihn nicht gestellt hast, ändere bitte dein Passwort.",
      admin_title: "Wiederherstellungsanträge ohne Code",
      admin_disabled: "Die Wiederherstellung per E-Mail ist nicht aktiviert.",
      admin_empty: "Keine offenen Anträge.",
      admin_meta: "Beantragt {created} · E-Mail bestätigt {confirmed} · Wartezeit bis {wait}",
      admin_approve: "Freigeben",
      admin_approve_info: "Nur freigeben, wenn du die Identität der Person persönlich geprüft hast. Die Wartezeit wird dadurch nicht verkürzt.",
      admin_confirm_email: "Zur Bestätigung E-Mail eingeben ({email})",
      admin_reason: "Begründung",
      admin_approved: "Freigabe erteilt.",
      admin_reject: "Ablehnen",
      admin_rejected: "Antrag abgelehnt.",
      admin_wait_email: "Freigabe erst möglich, wenn die Person den E-Mail-Link bestätigt hat.",
    },
    codes_title: "Deine Wiederherstellungscodes",
    codes_subtitle: "Bewahre diese Codes sicher auf (z. B. im Passwort-Manager). Sie werden nur EINMAL angezeigt, und jeder Code funktioniert nur ein einziges Mal.",
    codes_ack: "Ich habe diese Codes sicher gespeichert.",
    codes_continue: "Zum Dashboard",
    codes_copy: "Codes kopieren",
    codes_copied: "Kopiert",
    control_os_title: "Visibilis Control OS",
    tagline: "Der sichere Arbeitsbereich für Prüfung, Moderation und Plattformsteuerung.",
    function_line: "Mitglieder prüfen · Aktivitäten freigeben · Sicherheit verwalten",
    brand_team: "Nur für internes Team", brand_admin: "Martin = einziger Super Admin", brand_2fa: "2FA geschützt",
    card_title: "Sicher anmelden", card_subtitle: "Nur für Martin und berechtigte Visibilis-Teammitglieder.",
    show_password: "Passwort anzeigen", hide_password: "Passwort verbergen",
    next_hint: "Danach folgt die 2FA-Bestätigung mit Authenticator-App.",
    status_internal: "Geschützter interner Zugang", status_no_public: "Keine öffentliche Registrierung",
    preview_badge: "PREVIEW – keine Produktionsdaten",
    footer_rights: "© 2026 Visibilis.Life – Alle Rechte vorbehalten.",
    footer_privacy: "Datenschutz", footer_imprint: "Impressum", footer_support: "Support",
  },
  overview: {
    title: "Übersicht", subtitle: "Aktueller Stand des gemeinsamen Visibilis-Kerns.",
    kpi_members: "Mitglieder gesamt", kpi_reviews: "Offene Profilprüfungen",
    kpi_reports: "Offene Meldungen", kpi_activities: "Aktive Aktivitäten",
    recent_activity: "Letzte Aktivitäten (Audit-Log)", pending_reviews: "Wartende Profilprüfungen",
    critical_reports: "Kritische Meldungen", none_critical: "Keine kritischen Meldungen. Alles sicher.",
  },
  members: {
    title: "Mitglieder", subtitle: "Gemeinsame Mitgliederdaten aus der App.",
    col_name: "Name", col_city: "Ort", col_org: "Organisation", col_languages: "Sprachen",
    col_verification: "Verifizierung", col_joined: "Beitritt",
    search_placeholder: "Nach Name suchen …", org_all: "Alle Organisationen",
    col_accesspass: "Access Pass", view_pass: "Anzeigen",
  },
  reviews: {
    title: "Profilprüfungen", subtitle: "Neue und geänderte Profile freigeben oder ablehnen.",
    col_member: "Mitglied", col_type: "Typ", col_note: "Hinweis", col_submitted: "Eingereicht",
    approved_toast: "Profil genehmigt und Mitglied verifiziert.", rejected_toast: "Profil abgelehnt.",
  },
  activities: {
    title: "Aktivitäten", subtitle: "Aktivitäten freigeben – danach in der Mitglieder-App sichtbar.",
    col_title: "Titel", col_category: "Kategorie", col_location: "Ort", col_date: "Datum",
    col_participants: "Teilnehmer", approved_toast: "Aktivität freigegeben.", rejected_toast: "Aktivität abgelehnt.",
  },
  groups: {
    title: "Kreise & Gruppen", subtitle: "Gemeinschaften innerhalb von Visibilis Life.", members_count: "Mitglieder",
  },
  reports: {
    title: "Meldungen & Sicherheit", subtitle: "Sichere Moderation – nur für berechtigte Personen sichtbar.",
    col_title: "Meldung", col_context: "Kontext", col_severity: "Schweregrad", col_reporter: "Melder",
    in_progress_toast: "Meldung als in Bearbeitung markiert.", resolved_toast: "Meldung als gelöst markiert.",
  },
  pilot: {
    title: "Pilot & Auswertung", subtitle: "Kennzahlen und Entwicklung des Pilotbetriebs.",
    signups: "Neuregistrierungen pro Monat", participation: "Teilnahme nach Kategorie",
    months: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun"],
    kpi_verified: "Verifizierte Mitglieder", kpi_activities: "Aktive Aktivitäten",
    kpi_reviews: "Abgeschlossene Prüfungen", kpi_satisfaction: "Zufriedenheit",
  },
  placeholder: {
    subtitle: "Dieser Bereich wird in einer späteren Phase aktiviert.",
    body: "Der gemeinsame sichere Kern, die Rollen und das Audit-Log sind bereits vorbereitet. Diese Oberfläche folgt nach deiner Freigabe.",
  },
  accesspass: {
    title: "Access Pass", consent_granted: "Freigabe durch die betroffene Person erteilt",
    locked_title: "Zugriff gesperrt",
    locked_body: "Access-Pass-Daten sind nur nach ausdrücklicher Freigabe der betroffenen Person sichtbar.",
    request: "Freigabe anfordern", requested_toast: "Freigabe wurde bei der Person angefragt.",
    simulate: "Freigabe simulieren (nur Preview)", simulated_toast: "Freigabe simuliert – Access Pass ist jetzt sichtbar.",
    field_number: "Pass-Nummer", field_category: "Kategorie", field_valid: "Gültig bis",
    field_benefits: "Vergünstigungen", field_issued: "Ausgestellt von",
  },
  noaccess: { title: "Keine Berechtigung", body: "Ihre Rolle hat keine Berechtigung für diesen Bereich. Bei Bedarf wenden Sie sich an den Super Admin." },
  categories: { soziales: "Soziales", sport: "Sport", kultur: "Kultur", bildung: "Bildung", freizeit: "Freizeit", regional: "Regional" },
  audit: {
    title: "Audit-Log", subtitle: "Vollständiges, unveränderliches Ereignisprotokoll – ausschließlich für den Super Admin.",
    readonly_note: "Audit-Einträge sind schreibgeschützt und können nicht bearbeitet oder gelöscht werden.",
    search_placeholder: "Nach Nutzer, Aktion, Ereignis-ID, IP …",
    date_placeholder: "TT.MM.JJJJ",
    filter_area: "Bereich", filter_action: "Aktion", filter_actor: "Nutzer", filter_severity: "Sicherheitsrelevanz",
    filter_from: "Von", filter_to: "Bis", filter_security_only: "Nur sicherheitsrelevante",
    col_time: "Datum & Uhrzeit", col_actor: "Nutzer & Rolle", col_area: "Bereich", col_action: "Aktion",
    col_target: "Betroffen", col_status: "Status", col_severity: "Stufe", col_security: "Sicherheit",
    col_event: "Ereignis-ID", col_ip: "IP-Adresse", col_session: "Sitzung",
    detail_title: "Audit-Detail", no_results: "Keine Einträge für diese Filter.",
    showing: "Einträge", page_of: "Seite {page} von {pages}", prev: "Zurück", next: "Weiter",
    security_yes: "sicherheitsrelevant", security_no: "normal",
    severity: { info: "Info", warning: "Warnung", critical: "Kritisch" },
    area_label: {
      auth: "Authentifizierung", members: "Mitglieder", reviews: "Profilprüfungen",
      activities: "Aktivitäten", reports: "Meldungen", groups: "Gruppen",
      member_app: "Mitglieder-App", system: "System", overview: "Übersicht & Aufgaben", organizations: "Organisationen",
      support: "Support", content: "Inhalte", notifications: "Benachrichtigungen", pilot: "Pilot & Auswertung",
    },
    status_label: {
      ok: "Erfolgreich", failed: "Fehlgeschlagen", denied: "Verweigert", approved: "Genehmigt",
      rejected: "Abgelehnt", in_progress: "In Bearbeitung", resolved: "Gelöst", open: "Offen", requested: "Angefragt",
    },
    actions: {
      "2fa.recovery_failed": "2FA-Wiederherstellung fehlgeschlagen", "2fa.recovery_success": "2FA wiederhergestellt",
      "account.sessions_revoked": "Sitzungen beendet", "activity.access_requested": "Zugangsangabe angefragt",
      "activity.access_updated": "Zugangsangaben geändert", "activity.cancelled": "Aktivität abgesagt",
      "activity.draft_created": "Aktivitätsentwurf erstellt", "activity.participation_accept_companion": "Teilnahme mit Begleitung bestätigt",
      "activity.participation_waitlist": "Auf Warteliste gesetzt", "activity.participation_accept": "Teilnahme bestätigt",
      "activity.participation_decline": "Teilnahme abgelehnt", "activity.participation_waitlist_companion": "Begleitplatz auf Warteliste gesetzt",
      "activity.participation_decline_companion": "Begleitplatz abgelehnt", "activity.rescheduled": "Termin oder Treffpunkt geändert",
      "activity.seats_changed": "Plätze geändert", "activity.self_approval_denied": "Eigenfreigabe verweigert",
      "appeal.assigned": "Einspruch zugewiesen", "appeal.decided": "Einspruch entschieden", "audit.exported": "Audit-Log exportiert",
      "auth.password_reset_requested": "Passwort-Link angefordert", "community.comment_hide": "Kommentar ausgeblendet",
      "community.comment_restore": "Kommentar wiederhergestellt", "community.post_ask": "Rückfrage zu Beitrag",
      "community.post_hide": "Beitrag ausgeblendet", "community.post_remove": "Beitrag entfernt", "community.post_restore": "Beitrag wiederhergestellt",
      "content.created": "Inhalt erstellt", "content.plain_language_decided": "Textprüfung entschieden",
      "content.plain_language_proposed": "Einfachere Fassung vorgeschlagen", "group.join_policy_changed": "Beitrittsregel geändert",
      "group.membership_approved": "Aufnahme bestätigt", "group.membership_declined": "Aufnahme abgelehnt", "group.paused": "Gruppe pausiert",
      "member.access_pass_granted": "Access Pass freigegeben (Mitglied)", "member.access_pass_revoked": "Access-Pass-Freigabe widerrufen (Mitglied)",
      "member.activity.requested": "Teilnahme angefragt (Mitglied)", "member.activity.waitlisted": "Warteliste (Mitglied)",
      "member.appeal_created": "Einspruch eingereicht (Mitglied)", "member.auth.ambiguous": "Mitgliederanmeldung mehrdeutig",
      "member.auth.denied_inactive": "Mitgliederanmeldung verweigert (inaktiv)", "member.block.added": "Kontakt blockiert (Mitglied)",
      "member.block.removed": "Blockierung aufgehoben (Mitglied)", "member.comment.created": "Kommentar erstellt (Mitglied)",
      "member.comment.edited": "Kommentar bearbeitet (Mitglied)", "member.comment.removed": "Kommentar entfernt (Mitglied)",
      "member.data_request_created": "Datenanfrage erfasst", "member.dm.accepted": "Kontaktanfrage angenommen (Mitglied)",
      "member.dm.declined": "Kontaktanfrage abgelehnt (Mitglied)", "member.dm.ratelimited": "Kontaktanfragen begrenzt (Mitglied)",
      "member.dm.requested": "Kontaktanfrage gestellt (Mitglied)", "member.exported": "Mitgliedsdaten exportiert",
      "member.group.left": "Gruppe verlassen (Mitglied)", "member.group.requested": "Gruppenaufnahme angefragt (Mitglied)",
      "member.invitation_revoked": "Mitgliedseinladung widerrufen", "member.invited": "Mitglied eingeladen",
      "member.note_added": "Interne Notiz erfasst", "member.post.created": "Beitrag erstellt (Mitglied)",
      "member.post.edited": "Beitrag bearbeitet (Mitglied)", "member.post.removed": "Beitrag entfernt (Mitglied)",
      "member.report.created": "Meldung erstellt (Mitglied)", "member.status_changed": "Mitgliedsstatus geändert",
      "notification.scheduled": "Benachrichtigung geplant", "org.activity_submitted": "Aktivität von Organisation eingereicht",
      "org.participation_accept": "Teilnahme durch Organisation bestätigt", "org.participation_accept_companion": "Teilnahme mit Begleitung durch Organisation bestätigt",
      "org_claim.created": "Organisationsanspruch erfasst", "org_claim.lead_confirmed": "Organisationsleitung bestätigt",
      "org_claim.reviewed": "Organisationsanspruch geprüft", "org_location.created": "Standort erfasst", "org_location.reviewed": "Standort geprüft",
      "org_role.assigned": "Organisationsrolle vergeben", "org_role.revoked": "Organisationsrolle entzogen", "organization.created": "Organisation erfasst",
      "pilot.exported": "Pilotauswertung exportiert", "qa.result_recorded": "Prüfergebnis erfasst", "report.claimed": "Meldung übernommen",
      "report.feedback_sent": "Rückmeldung gesendet", "report.prioritized": "Meldung priorisiert", "report.restriction_lifted": "Einschränkung aufgehoben",
      "report.restriction_set": "Vorübergehende Einschränkung gesetzt", "report.status_changed": "Meldungsstatus geändert",
      "review.changes_requested": "Rückfrage zum Profil", "saved_view.created": "Arbeitsansicht gespeichert", "saved_view.deleted": "Arbeitsansicht gelöscht",
      "settings.countries_saved": "Ländereinstellungen gespeichert", "support.handover": "Supportfall weitergegeben", "support.replied": "Support-Antwort gesendet",
      "support.resolved": "Supportfall gelöst", "support.ticket_created": "Supportanfrage erfasst", "system.admin_config.viewed": "Systemkonfiguration angesehen",
      "system.incident_created": "Störung erfasst", "system.incident_updated": "Störung aktualisiert", "task.assigned": "Aufgabe zugewiesen",
      "team.invitation_accepted": "Teameinladung angenommen", "team.invited": "Teammitglied eingeladen", "team.organizations_changed": "Organisationszuordnung geändert",

      "login.success": "Anmeldung erfolgreich", "login.2fa_failed": "2FA fehlgeschlagen",
      "logout": "Abmeldung", "2fa.enrolled": "2FA eingerichtet",
      "access_pass.viewed": "Access Pass angesehen", "access_pass.denied": "Access-Pass-Zugriff verweigert",
      "access_pass.requested": "Access-Pass-Freigabe angefragt", "access_pass.consent_simulated": "Freigabe simuliert",
      "review.approved": "Profil genehmigt", "review.rejected": "Profil abgelehnt",
      "activity.approved": "Aktivität freigegeben", "activity.rejected": "Aktivität abgelehnt",
      "report.in_progress": "Meldung in Bearbeitung", "report.resolved": "Meldung gelöst", "report.opened": "Meldung eröffnet",
      "member.login.success": "Mitglied angemeldet", "member.logout": "Mitglied abgemeldet",
      "member.activity.joined": "Aktivität beigetreten", "member.activity.left": "Aktivität verlassen",
      "member.group.joined": "Gruppe beigetreten",
    },
  },
  member: {
    app_name: "Visibilis Life", tagline: "Gemeinschaft, Freundschaften und Teilhabe.",
    nav: { start: "Start", activities: "Aktivitäten", groups: "Kreise & Gruppen", messages: "Nachrichten", profile: "Mein Profil" },
    login: {
      title: "Willkommen zurück", subtitle: "Melde dich in deiner Mitglieder-App an.",
      email: "E-Mail-Adresse", password: "Passwort", submit: "Anmelden",
      demo_hint: "Demo-Zugang (Preview)", show_password: "Passwort anzeigen", hide_password: "Passwort verbergen",
      no_dating: "Visibilis Life ist keine Dating-Plattform – hier geht es um Freundschaften, Interessen und Teilhabe.",
      preview_badge: "PREVIEW – keine echten Daten",
    },
    start: {
      greeting: "Hallo {name}", intro: "Schön, dass du da bist. Hier ist, was gerade läuft.",
      announcements: "Neuigkeiten", upcoming: "Kommende Aktivitäten", suggested_groups: "Vorgeschlagene Kreise",
      empty: "Momentan nichts Neues.",
    },
    activities: {
      title: "Aktivitäten", subtitle: "Sichere, gemeinsame Aktivitäten in deiner Nähe.",
      join: "Teilnehmen", joined: "Angemeldet", leave: "Abmelden",
      participants: "Teilnehmende", capacity: "Plätze", when: "Wann", where: "Wo",
      all: "Alle", empty: "Keine Aktivitäten gefunden.",
      joined_toast: "Du nimmst jetzt teil.", left_toast: "Du hast dich abgemeldet.",
    },
    groups: {
      title: "Kreise & Gruppen", subtitle: "Finde Gemeinschaften mit gemeinsamen Interessen.",
      join: "Beitreten", joined: "Beigetreten", leave: "Verlassen", members: "Mitglieder", empty: "Keine Gruppen gefunden.",
      joined_toast: "Du bist der Gruppe beigetreten.", left_toast: "Du hast die Gruppe verlassen.",
    },
    messages: {
      title: "Nachrichten", subtitle: "Freundlicher Austausch in der Gemeinschaft.",
      empty: "Keine Unterhaltungen.", placeholder: "Nachricht schreiben …", send: "Senden",
      community_note: "Bitte bleib freundlich und respektvoll.", select_hint: "Wähle links eine Unterhaltung.",
    },
    profile: {
      title: "Mein Profil", edit: "Bearbeiten", save: "Speichern", cancel: "Abbrechen",
      bio: "Über mich", bio_placeholder: "Erzähle kurz etwas über dich …",
      interests: "Interessen", languages: "Sprachen", city: "Ort",
      stat_activities: "Aktivitäten", stat_groups: "Gruppen",
      access_pass: "Access Pass", pass_number: "Pass-Nummer", valid_until: "Gültig bis", no_pass: "Kein Access Pass hinterlegt.",
      logout: "Abmelden", saved_toast: "Profil gespeichert.",
      sections: "Einstellungen & Hilfe",
      security: "Sicherheit", security_2fa: "Zwei-Faktor-Authentifizierung",
      security_2fa_off: "Nicht aktiviert", security_2fa_on: "Aktiviert",
      security_2fa_note: "In dieser Preview optional. Eine spätere Aktivierung ist bereits vorbereitet.",
      help: "Hilfe", help_body: "Fragen? Unser Team hilft dir gerne weiter.",
      help_topics: "Häufige Themen: Aktivitäten, Gruppen, Sicherheit, Konto.",
      accessibility: "Barrierefreiheit", high_contrast: "Hoher Kontrast", large_text: "Grosse Schrift",
      reduce_motion: "Weniger Bewegung", accessibility_note: "Einstellungen für bessere Lesbarkeit und Bedienung.",
      account: "Konto", account_email: "E-Mail", account_note: "Demo-Konto – keine echten Daten, keine echten E-Mails.",
      notifications: "Benachrichtigungen",
    },
    categories: {
      soziales: "Soziales", sport: "Sport", kultur: "Kultur", bildung: "Bildung",
      freizeit: "Freizeit", regional: "Regional",
    },
  },
};

const en = {
  app: { name: "Visibilis Control OS", env_production: "PROD", env_preview: "PREVIEW", env_test: "TEST", env_dev: "DEV", env_unknown: "Environment unknown" },
  nav: {
    overview: "Overview", both_apps: "Apps & management", members: "Members", reviews: "Profile reviews",
    activities: "Activities", groups: "Circles & Groups", reports: "Reports & Safety",
    organizations: "Organizations", support: "Support", content: "Content & Approvals",
    notifications: "Notifications", pilot: "Pilot & Analytics", audit: "Audit log",
    system: "System status", settings: "Settings", tasks: "My tasks", team: "Team & rights", help: "Help",
  },
  common: {
    search: "Search", filter: "Filter", all: "All", status: "Status", actions: "Actions",
    approve: "Approve", reject: "Reject", details: "Details", logout: "Sign out",
    role: "Role", language: "Language", loading: "Loading …", no_data: "No entries.",
    open_menu: "Open menu", skip_to_content: "Skip to content", in_preparation: "In preparation",
    mark_in_progress: "In progress", mark_resolved: "Mark resolved", view_all: "View all",
    reset: "Reset", back: "Back", save: "Save", cancel: "Cancel", close: "Close",
  },
  labels: {
    aktiv: "active", ausstehend: "pending", gesperrt: "blocked", offen: "open",
    genehmigt: "approved", abgelehnt: "rejected", freigegeben: "published",
    "in Bearbeitung": "in progress", "gelöst": "resolved", verifiziert: "verified",
    kritisch: "critical", mittel: "medium", niedrig: "low", ruhend: "dormant",
  },
  login: {
    title: "Sign in", subtitle: "Protected access for authorized team members.",
    email: "Email address", password: "Password", submit: "Continue",
    twofa_title: "Two-factor authentication",
    twofa_subtitle: "Enter the 6-digit code from your authenticator app.",
    twofa_submit: "Sign in", back: "Back",
    no_public: "No public registration. Internal team access only.",
    preview_hint: "Preview note: current demo code", preview_fill: "Use code",
    error_credentials: "Email or password is incorrect.",
    setup_title: "Set up two-factor authentication",
    setup_subtitle: "Scan the QR code with an authenticator app (e.g. Google Authenticator), then enter the displayed 6-digit code.",
    setup_secret_label: "Manual key (if you can't scan the QR)",
    setup_scan_hint: "Scan the QR code with the app", setup_confirm: "Complete setup",
    lost_authenticator: "Lost your authenticator?",
    recover_title: "Sign in with a recovery code",
    recover_subtitle: "Enter one of your one-time recovery codes. You'll then set up a new authenticator.",
    recover_code_label: "Recovery code",
    recover_submit: "Continue to re-setup",
    recover_no_codes: "No recovery codes left? Team members contact the Super Admin, who can trigger “Set up 2FA again” in Team. For the Super Admin, the documented operator procedure applies. Afterwards a new QR code appears at the next sign-in.",
    setup_incomplete: "Re-setup of your authenticator is not finished yet. Use “Lost your authenticator?” with the same recovery code to get a new QR code.",
    resume_setup: "Show QR code again",
    resume_setup_hint: "Your 2FA setup is not finished yet. While the setup session is valid (5 minutes), you can show the QR code again.",
    setup_expired: "Please sign in again.",
    mail_recovery: {
      title: "Without a recovery code",
      loading: "Loading status",
      intro: "You can request a recovery by email. This is a request, not an immediate unlock: you confirm the link in the email, then a waiting period of {hours} hours applies and an independent approval is required. Only then does a new QR code appear after signing in again.",
      request: "Request recovery by email",
      mail_missing: "Email delivery is not set up yet, so a request is not possible right now.",
      mail_handed_over: "The email was handed over to the delivery service. We cannot see whether it arrives. Please also check your spam folder.",
      email_open: "Confirm the link in the email by {time}. After that the request expires.",
      warning_pending: "Your confirmation is being processed: the warning email is being handed over to the delivery service. The waiting period starts only afterwards.",
      waiting: "The waiting period runs until {time}.",
      waiting_done: "The waiting period is over.",
      approval_super_admin: "Approval by the Super Admin is still pending.",
      approval_operator: "Approval via the operator procedure is still pending.",
      approved: "Approval has been granted.",
      operator_missing: "Blocked: the operator trust anchor is not set up. The request stays blocked until the operator carries out this step.",
      operator_step: "Operator step: in production, set SUPER_ADMIN_RECOVERY_TOKEN in the secret store and republish. Then approve request {id} with POST /api/internal/recovery/2fa-email-request/approve (header X-Recovery-Token). See the runbook.",
      ready: "All conditions are met. You can now set up a new authenticator.",
      complete: "Set up new QR code",
      cancel: "Cancel request",
      cancelled: "The request was cancelled.",
      expires: "The request expires at the latest on {time}.",
      closed: {
        abgeschlossen: "Your last request is completed.",
        abgebrochen: "Your last request was cancelled.",
        abgelehnt: "Your last request was rejected.",
        abgelaufen: "Your last request has expired.",
        versand_fehlgeschlagen: "For your last request the email could not be handed over to the delivery service. Nothing was activated.",
        warnung_fehlgeschlagen: "For your last request the warning email could not be handed over. The request was ended, nothing was activated.",
        "ungültig": "Your last request became invalid because the account was changed in the meantime.",
      },
      link_title: "2FA recovery",
      link_confirm_intro: "Confirm your request to recover two-factor sign-in here. The 24-hour waiting period starts afterwards.",
      link_cancel_intro: "Cancel the recovery request here. This takes effect immediately.",
      link_confirm: "Confirm request",
      link_cancel: "Cancel request now",
      link_invalid: "This link is not valid or has expired.",
      link_confirmed: "Request confirmed. The waiting period runs until {time}.",
      link_next_super_admin: "After that the Super Admin has to approve the request. Then sign in again and choose “Lost your authenticator?”.",
      link_next_operator: "After that an approval via the operator procedure is required. Then sign in again and choose “Lost your authenticator?”.",
      link_warning_sent: "A warning email with a cancel link was handed over to the delivery service.",
      link_warning_failed: "The warning email could not be handed over to the delivery service. The request still runs; you can cancel it when signing in.",
      link_cancelled: "The request is cancelled. If you did not make it, please change your password.",
      admin_title: "Recovery requests without code",
      admin_disabled: "Recovery by email is not enabled.",
      admin_empty: "No open requests.",
      admin_meta: "Requested {created} · email confirmed {confirmed} · waiting until {wait}",
      admin_approve: "Approve",
      admin_approve_info: "Only approve if you have personally verified the person's identity. This does not shorten the waiting period.",
      admin_confirm_email: "Enter the email to confirm ({email})",
      admin_reason: "Reason",
      admin_approved: "Approval granted.",
      admin_reject: "Reject",
      admin_rejected: "Request rejected.",
      admin_wait_email: "Approval is only possible once the person has confirmed the email link.",
    },
    codes_title: "Your recovery codes",
    codes_subtitle: "Store these codes safely (e.g. in a password manager). They are shown only ONCE and each code works a single time.",
    codes_ack: "I have saved these codes securely.",
    codes_continue: "Go to dashboard",
    codes_copy: "Copy codes",
    codes_copied: "Copied",
    control_os_title: "Visibilis Control OS",
    tagline: "The secure workspace for review, moderation and platform control.",
    function_line: "Review members · Approve activities · Manage safety",
    brand_team: "Internal team only", brand_admin: "Martin = sole Super Admin", brand_2fa: "2FA protected",
    card_title: "Sign in securely", card_subtitle: "For Martin and authorized Visibilis team members only.",
    show_password: "Show password", hide_password: "Hide password",
    next_hint: "The 2FA confirmation with your authenticator app follows next.",
    status_internal: "Protected internal access", status_no_public: "No public registration",
    preview_badge: "PREVIEW – no production data",
    footer_rights: "© 2026 Visibilis.Life – All rights reserved.",
    footer_privacy: "Privacy", footer_imprint: "Imprint", footer_support: "Support",
  },
  overview: {
    title: "Overview", subtitle: "Current state of the shared Visibilis core.",
    kpi_members: "Total members", kpi_reviews: "Open profile reviews",
    kpi_reports: "Open reports", kpi_activities: "Active activities",
    recent_activity: "Recent activity (audit log)", pending_reviews: "Pending reviews",
    critical_reports: "Critical reports", none_critical: "No critical reports. All safe.",
  },
  members: {
    title: "Members", subtitle: "Shared member data from the app.",
    col_name: "Name", col_city: "City", col_org: "Organization", col_languages: "Languages",
    col_verification: "Verification", col_joined: "Joined",
    search_placeholder: "Search by name …", org_all: "All organizations",
    col_accesspass: "Access Pass", view_pass: "View",
  },
  reviews: {
    title: "Profile reviews", subtitle: "Approve or reject new and changed profiles.",
    col_member: "Member", col_type: "Type", col_note: "Note", col_submitted: "Submitted",
    approved_toast: "Profile approved and member verified.", rejected_toast: "Profile rejected.",
  },
  activities: {
    title: "Activities", subtitle: "Approve activities – then visible in the member app.",
    col_title: "Title", col_category: "Category", col_location: "Location", col_date: "Date",
    col_participants: "Participants", approved_toast: "Activity published.", rejected_toast: "Activity rejected.",
  },
  groups: {
    title: "Circles & Groups", subtitle: "Communities within Visibilis Life.", members_count: "members",
  },
  reports: {
    title: "Reports & Safety", subtitle: "Safe moderation – visible to authorized people only.",
    col_title: "Report", col_context: "Context", col_severity: "Severity", col_reporter: "Reporter",
    in_progress_toast: "Report marked in progress.", resolved_toast: "Report resolved.",
  },
  pilot: {
    title: "Pilot & Analytics", subtitle: "Metrics and trends of the pilot phase.",
    signups: "Sign-ups per month", participation: "Participation by category",
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    kpi_verified: "Verified members", kpi_activities: "Active activities",
    kpi_reviews: "Completed reviews", kpi_satisfaction: "Satisfaction",
  },
  placeholder: {
    subtitle: "This section will be activated in a later phase.",
    body: "The shared secure core, roles and audit log are already prepared. This surface follows after your approval.",
  },
  accesspass: {
    title: "Access Pass", consent_granted: "Consent granted by the affected person",
    locked_title: "Access locked",
    locked_body: "Access Pass data is only visible after explicit consent of the affected person.",
    request: "Request consent", requested_toast: "Consent has been requested from the person.",
    simulate: "Simulate consent (preview only)", simulated_toast: "Consent simulated – Access Pass is now visible.",
    field_number: "Pass number", field_category: "Category", field_valid: "Valid until",
    field_benefits: "Benefits", field_issued: "Issued by",
  },
  noaccess: { title: "No access", body: "Your role has no permission for this area." },
  categories: { soziales: "Social", sport: "Sport", kultur: "Culture", bildung: "Education", freizeit: "Leisure", regional: "Regional" },
  audit: {
    title: "Audit log", subtitle: "Complete, immutable event log – reserved exclusively for the Super Admin.",
    readonly_note: "Audit entries are read-only and cannot be edited or deleted.",
    search_placeholder: "By user, action, event ID, IP …",
    date_placeholder: "DD.MM.YYYY",
    filter_area: "Area", filter_action: "Action", filter_actor: "User", filter_severity: "Security relevance",
    filter_from: "From", filter_to: "To", filter_security_only: "Security-relevant only",
    col_time: "Date & time", col_actor: "User & role", col_area: "Area", col_action: "Action",
    col_target: "Affected", col_status: "Status", col_severity: "Level", col_security: "Security",
    col_event: "Event ID", col_ip: "IP address", col_session: "Session",
    detail_title: "Audit detail", no_results: "No entries for these filters.",
    showing: "entries", page_of: "Page {page} of {pages}", prev: "Previous", next: "Next",
    security_yes: "security-relevant", security_no: "normal",
    severity: { info: "Info", warning: "Warning", critical: "Critical" },
    area_label: {
      auth: "Authentication", members: "Members", reviews: "Profile reviews",
      activities: "Activities", reports: "Reports", groups: "Groups",
      member_app: "Member app", system: "System", overview: "Overview & tasks", organizations: "Organisations",
      support: "Support", content: "Content", notifications: "Notifications", pilot: "Pilot & evaluation",
    },
    status_label: {
      ok: "Successful", failed: "Failed", denied: "Denied", approved: "Approved",
      rejected: "Rejected", in_progress: "In progress", resolved: "Resolved", open: "Open", requested: "Requested",
    },
    actions: {
      "login.success": "Sign-in successful", "login.2fa_failed": "2FA failed",
      "logout": "Sign-out", "2fa.enrolled": "2FA enrolled",
      "access_pass.viewed": "Access Pass viewed", "access_pass.denied": "Access Pass denied",
      "access_pass.requested": "Access Pass requested", "access_pass.consent_simulated": "Consent simulated",
      "review.approved": "Profile approved", "review.rejected": "Profile rejected",
      "activity.approved": "Activity approved", "activity.rejected": "Activity rejected",
      "report.in_progress": "Report in progress", "report.resolved": "Report resolved", "report.opened": "Report opened",
      "member.login.success": "Member signed in", "member.logout": "Member signed out",
      "member.activity.joined": "Joined activity", "member.activity.left": "Left activity",
      "member.group.joined": "Joined group",
    },
  },
  member: {
    app_name: "Visibilis Life", tagline: "Community, friendships and participation.",
    nav: { start: "Home", activities: "Activities", groups: "Circles & Groups", messages: "Messages", profile: "My profile" },
    login: {
      title: "Welcome back", subtitle: "Sign in to your member app.",
      email: "Email address", password: "Password", submit: "Sign in",
      demo_hint: "Demo access (preview)", show_password: "Show password", hide_password: "Hide password",
      no_dating: "Visibilis Life is not a dating platform – it's about friendships, interests and participation.",
      preview_badge: "PREVIEW – no real data",
    },
    start: {
      greeting: "Hi {name}", intro: "Glad you're here. Here's what's happening.",
      announcements: "News", upcoming: "Upcoming activities", suggested_groups: "Suggested circles",
      empty: "Nothing new right now.",
    },
    activities: {
      title: "Activities", subtitle: "Safe, shared activities near you.",
      join: "Join", joined: "Joined", leave: "Leave",
      participants: "Participants", capacity: "Spots", when: "When", where: "Where",
      all: "All", empty: "No activities found.",
      joined_toast: "You're taking part now.", left_toast: "You left the activity.",
    },
    groups: {
      title: "Circles & Groups", subtitle: "Find communities with shared interests.",
      join: "Join", joined: "Joined", leave: "Leave", members: "members", empty: "No groups found.",
      joined_toast: "You joined the group.", left_toast: "You left the group.",
    },
    messages: {
      title: "Messages", subtitle: "Friendly exchange within the community.",
      empty: "No conversations.", placeholder: "Write a message …", send: "Send",
      community_note: "Please stay friendly and respectful.", select_hint: "Pick a conversation on the left.",
    },
    profile: {
      title: "My profile", edit: "Edit", save: "Save", cancel: "Cancel",
      bio: "About me", bio_placeholder: "Tell us a little about yourself …",
      interests: "Interests", languages: "Languages", city: "City",
      stat_activities: "Activities", stat_groups: "Groups",
      access_pass: "Access Pass", pass_number: "Pass number", valid_until: "Valid until", no_pass: "No Access Pass on file.",
      logout: "Sign out", saved_toast: "Profile saved.",
      sections: "Settings & help",
      security: "Security", security_2fa: "Two-factor authentication",
      security_2fa_off: "Not enabled", security_2fa_on: "Enabled",
      security_2fa_note: "Optional in this preview. Later activation is already prepared.",
      help: "Help", help_body: "Questions? Our team is happy to help.",
      help_topics: "Common topics: activities, groups, safety, account.",
      accessibility: "Accessibility", high_contrast: "High contrast", large_text: "Large text",
      reduce_motion: "Reduce motion", accessibility_note: "Settings for better readability and use.",
      account: "Account", account_email: "Email", account_note: "Demo account – no real data, no real emails.",
      notifications: "Notifications",
    },
    categories: {
      soziales: "Social", sport: "Sport", kultur: "Culture", bildung: "Education",
      freizeit: "Leisure", regional: "Regional",
    },
  },
};

const fr = {
  app: { name: "Visibilis Control OS", env_production: "PROD", env_preview: "APERÇU", env_test: "TEST", env_dev: "DEV", env_unknown: "Environnement inconnu" },
  nav: {
    overview: "Aperçu", both_apps: "Applications et gestion", members: "Membres", reviews: "Vérifications de profil",
    activities: "Activités", groups: "Cercles & Groupes", reports: "Signalements & Sécurité",
    organizations: "Organisations", support: "Support", content: "Contenus & Validations",
    notifications: "Notifications", pilot: "Pilote & Analyse", audit: "Journal d'audit",
    system: "État du système", settings: "Paramètres", tasks: "Mes tâches", team: "Équipe & droits", help: "Aide",
  },
  common: {
    search: "Rechercher", filter: "Filtre", all: "Tous", status: "Statut", actions: "Actions",
    approve: "Approuver", reject: "Refuser", details: "Détails", logout: "Se déconnecter",
    role: "Rôle", language: "Langue", loading: "Chargement …", no_data: "Aucune entrée.",
    open_menu: "Ouvrir le menu", skip_to_content: "Aller au contenu", in_preparation: "En préparation",
    mark_in_progress: "En traitement", mark_resolved: "Marquer résolu", view_all: "Tout afficher",
    reset: "Réinitialiser", back: "Retour", save: "Enregistrer", cancel: "Annuler", close: "Fermer",
  },
  labels: {
    aktiv: "actif", ausstehend: "en attente", gesperrt: "bloqué", offen: "ouvert",
    genehmigt: "approuvé", abgelehnt: "refusé", freigegeben: "publié",
    "in Bearbeitung": "en traitement", "gelöst": "résolu", verifiziert: "vérifié",
    kritisch: "critique", mittel: "moyen", niedrig: "faible", ruhend: "en veille",
  },
  login: {
    title: "Connexion", subtitle: "Accès protégé pour les membres autorisés.",
    email: "Adresse e-mail", password: "Mot de passe", submit: "Continuer",
    twofa_title: "Authentification à deux facteurs",
    twofa_subtitle: "Saisissez le code à 6 chiffres de votre application.",
    twofa_submit: "Se connecter", back: "Retour",
    no_public: "Pas d'inscription publique. Accès équipe interne uniquement.",
    preview_hint: "Note preview : code démo actuel", preview_fill: "Utiliser le code",
    error_credentials: "E-mail ou mot de passe incorrect.",
    setup_title: "Configurer l'authentification à deux facteurs",
    setup_subtitle: "Scannez le code QR avec une application d'authentification (par ex. Google Authenticator), puis saisissez le code à 6 chiffres affiché.",
    setup_secret_label: "Clé manuelle (si le QR n'est pas scannable)",
    setup_scan_hint: "Scanner le code QR avec l'application", setup_confirm: "Terminer la configuration",
    lost_authenticator: "Authenticator perdu ?",
    recover_title: "Se connecter avec un code de récupération",
    recover_subtitle: "Saisissez l'un de vos codes de récupération à usage unique. Vous configurerez ensuite un nouvel authenticator.",
    recover_code_label: "Code de récupération",
    recover_submit: "Continuer vers la reconfiguration",
    recover_no_codes: "Plus de codes de récupération ? Les membres de l'équipe contactent le Super Admin, qui peut déclencher « Reconfigurer la 2FA » dans l'équipe. Pour le Super Admin, la procédure opérateur documentée s'applique. Un nouveau code QR apparaît ensuite à la prochaine connexion.",
    setup_incomplete: "La reconfiguration de votre authenticator n'est pas terminée. Via « Authenticator perdu ? », le même code de récupération vous donne un nouveau code QR.",
    resume_setup: "Afficher à nouveau le code QR",
    resume_setup_hint: "Votre configuration 2FA n'est pas encore terminée. Tant que la session de configuration est valide (5 minutes), vous pouvez afficher à nouveau le code QR.",
    setup_expired: "Veuillez vous reconnecter.",
    mail_recovery: {
      title: "Sans code de récupération",
      loading: "Chargement du statut",
      intro: "Vous pouvez demander une récupération par e-mail. Il s'agit d'une demande, pas d'un déblocage immédiat : vous confirmez le lien dans l'e-mail, puis un délai d'attente de {hours} heures s'applique et une validation indépendante est nécessaire. Ce n'est qu'ensuite qu'un nouveau code QR apparaît après une nouvelle connexion.",
      request: "Demander la récupération par e-mail",
      mail_missing: "L'envoi d'e-mails n'est pas encore configuré. Une demande n'est donc pas possible pour le moment.",
      mail_handed_over: "L'e-mail a été remis au service d'envoi. Nous ne pouvons pas voir s'il arrive. Vérifiez aussi le dossier spam.",
      email_open: "Confirmez le lien de l'e-mail avant le {time}. Ensuite, la demande expire.",
      warning_pending: "Votre confirmation est en cours : l'e-mail d'avertissement est remis au service d'envoi. Le délai d'attente ne commence qu'ensuite.",
      waiting: "Le délai d'attente court jusqu'au {time}.",
      waiting_done: "Le délai d'attente est écoulé.",
      approval_super_admin: "La validation par le Super Admin est en attente.",
      approval_operator: "La validation via la procédure opérateur est en attente.",
      approved: "La validation est accordée.",
      operator_missing: "Bloqué : l'ancre de confiance de l'opérateur n'est pas configurée. La demande reste bloquée jusqu'à ce que l'opérateur effectue cette étape.",
      operator_step: "Étape opérateur : en production, définir SUPER_ADMIN_RECOVERY_TOKEN dans le Secret Store et republier. Puis valider la demande {id} avec POST /api/internal/recovery/2fa-email-request/approve (en-tête X-Recovery-Token). Voir le runbook.",
      ready: "Toutes les conditions sont remplies. Vous pouvez maintenant configurer un nouvel authenticator.",
      complete: "Configurer un nouveau code QR",
      cancel: "Annuler la demande",
      cancelled: "La demande a été annulée.",
      expires: "La demande expire au plus tard le {time}.",
      closed: {
        abgeschlossen: "Votre dernière demande est terminée.",
        abgebrochen: "Votre dernière demande a été annulée.",
        abgelehnt: "Votre dernière demande a été refusée.",
        abgelaufen: "Votre dernière demande a expiré.",
        versand_fehlgeschlagen: "Pour votre dernière demande, l'e-mail n'a pas pu être remis au service d'envoi. Rien n'a été activé.",
        warnung_fehlgeschlagen: "Pour votre dernière demande, l'e-mail d'avertissement n'a pas pu être remis. La demande a été clôturée, rien n'a été activé.",
        "ungültig": "Votre dernière demande n'est plus valide, car le compte a été modifié entre-temps.",
      },
      link_title: "Récupération 2FA",
      link_confirm_intro: "Confirmez ici votre demande de récupération de la connexion à deux facteurs. Le délai d'attente de 24 heures commence ensuite.",
      link_cancel_intro: "Annulez ici la demande de récupération. L'annulation est immédiate.",
      link_confirm: "Confirmer la demande",
      link_cancel: "Annuler la demande maintenant",
      link_invalid: "Ce lien n'est pas valide ou a expiré.",
      link_confirmed: "Demande confirmée. Le délai d'attente court jusqu'au {time}.",
      link_next_super_admin: "Ensuite, le Super Admin doit valider la demande. Reconnectez-vous puis choisissez « Authenticator perdu ? ».",
      link_next_operator: "Ensuite, une validation via la procédure opérateur est nécessaire. Reconnectez-vous puis choisissez « Authenticator perdu ? ».",
      link_warning_sent: "Un e-mail d'avertissement avec un lien d'annulation a été remis au service d'envoi.",
      link_warning_failed: "L'e-mail d'avertissement n'a pas pu être remis au service d'envoi. La demande continue ; vous pouvez l'annuler lors de la connexion.",
      link_cancelled: "La demande est annulée. Si vous ne l'avez pas faite, veuillez changer votre mot de passe.",
      admin_title: "Demandes de récupération sans code",
      admin_disabled: "La récupération par e-mail n'est pas activée.",
      admin_empty: "Aucune demande ouverte.",
      admin_meta: "Demandée {created} · e-mail confirmé {confirmed} · attente jusqu'au {wait}",
      admin_approve: "Valider",
      admin_approve_info: "Ne validez que si vous avez vérifié personnellement l'identité de la personne. Le délai d'attente n'est pas raccourci.",
      admin_confirm_email: "Saisir l'e-mail pour confirmer ({email})",
      admin_reason: "Motif",
      admin_approved: "Validation accordée.",
      admin_reject: "Refuser",
      admin_rejected: "Demande refusée.",
      admin_wait_email: "Validation possible seulement après confirmation du lien e-mail par la personne.",
    },
    codes_title: "Vos codes de récupération",
    codes_subtitle: "Conservez ces codes en lieu sûr (par ex. un gestionnaire de mots de passe). Ils ne s'affichent qu'UNE SEULE fois et chaque code ne fonctionne qu'une fois.",
    codes_ack: "J'ai enregistré ces codes en lieu sûr.",
    codes_continue: "Vers le tableau de bord",
    codes_copy: "Copier les codes",
    codes_copied: "Copié",
    control_os_title: "Visibilis Control OS",
    tagline: "L'espace de travail sécurisé pour la vérification, la modération et le pilotage de la plateforme.",
    function_line: "Vérifier les membres · Valider les activités · Gérer la sécurité",
    brand_team: "Équipe interne uniquement", brand_admin: "Martin = seul Super Admin", brand_2fa: "Protégé par 2FA",
    card_title: "Connexion sécurisée", card_subtitle: "Réservé à Martin et aux membres autorisés de l'équipe Visibilis.",
    show_password: "Afficher le mot de passe", hide_password: "Masquer le mot de passe",
    next_hint: "La confirmation 2FA avec l'application d'authentification suit.",
    status_internal: "Accès interne protégé", status_no_public: "Pas d'inscription publique",
    preview_badge: "PREVIEW – aucune donnée de production",
    footer_rights: "© 2026 Visibilis.Life – Tous droits réservés.",
    footer_privacy: "Confidentialité", footer_imprint: "Mentions légales", footer_support: "Support",
  },
  overview: {
    title: "Aperçu", subtitle: "État actuel du cœur partagé de Visibilis.",
    kpi_members: "Membres au total", kpi_reviews: "Vérifications ouvertes",
    kpi_reports: "Signalements ouverts", kpi_activities: "Activités actives",
    recent_activity: "Activité récente (journal d'audit)", pending_reviews: "Vérifications en attente",
    critical_reports: "Signalements critiques", none_critical: "Aucun signalement critique. Tout est sûr.",
  },
  members: {
    title: "Membres", subtitle: "Données des membres partagées depuis l'app.",
    col_name: "Nom", col_city: "Ville", col_org: "Organisation", col_languages: "Langues",
    col_verification: "Vérification", col_joined: "Adhésion",
    search_placeholder: "Rechercher par nom …", org_all: "Toutes les organisations",
    col_accesspass: "Access Pass", view_pass: "Afficher",
  },
  reviews: {
    title: "Vérifications de profil", subtitle: "Approuver ou refuser les profils nouveaux et modifiés.",
    col_member: "Membre", col_type: "Type", col_note: "Note", col_submitted: "Soumis",
    approved_toast: "Profil approuvé et membre vérifié.", rejected_toast: "Profil refusé.",
  },
  activities: {
    title: "Activités", subtitle: "Valider les activités – ensuite visibles dans l'app membre.",
    col_title: "Titre", col_category: "Catégorie", col_location: "Lieu", col_date: "Date",
    col_participants: "Participants", approved_toast: "Activité publiée.", rejected_toast: "Activité refusée.",
  },
  groups: {
    title: "Cercles & Groupes", subtitle: "Communautés au sein de Visibilis Life.", members_count: "membres",
  },
  reports: {
    title: "Signalements & Sécurité", subtitle: "Modération sûre – visible uniquement par les personnes autorisées.",
    col_title: "Signalement", col_context: "Contexte", col_severity: "Gravité", col_reporter: "Signaleur",
    in_progress_toast: "Signalement marqué en traitement.", resolved_toast: "Signalement résolu.",
  },
  pilot: {
    title: "Pilote & Analyse", subtitle: "Indicateurs et évolution de la phase pilote.",
    signups: "Inscriptions par mois", participation: "Participation par catégorie",
    months: ["janv.", "févr.", "mars", "avr.", "mai", "juin"],
    kpi_verified: "Membres vérifiés", kpi_activities: "Activités actives",
    kpi_reviews: "Vérifications terminées", kpi_satisfaction: "Satisfaction",
  },
  placeholder: {
    subtitle: "Cette section sera activée dans une phase ultérieure.",
    body: "Le cœur sécurisé partagé, les rôles et le journal d'audit sont déjà prêts. Cette interface suivra après ta validation.",
  },
  accesspass: {
    title: "Access Pass", consent_granted: "Consentement accordé par la personne concernée",
    locked_title: "Accès verrouillé",
    locked_body: "Les données de l'Access Pass ne sont visibles qu'après le consentement explicite de la personne concernée.",
    request: "Demander le consentement", requested_toast: "Le consentement a été demandé à la personne.",
    simulate: "Simuler le consentement (preview uniquement)", simulated_toast: "Consentement simulé – l'Access Pass est maintenant visible.",
    field_number: "Numéro de pass", field_category: "Catégorie", field_valid: "Valable jusqu'au",
    field_benefits: "Avantages", field_issued: "Délivré par",
  },
  noaccess: { title: "Aucun accès", body: "Ton rôle n'a pas l'autorisation pour cette section." },
  categories: { soziales: "Social", sport: "Sport", kultur: "Culture", bildung: "Éducation", freizeit: "Loisirs", regional: "Régional" },
  audit: {
    title: "Journal d'audit", subtitle: "Journal d'événements complet et immuable – réservé exclusivement au Super Admin.",
    readonly_note: "Les entrées d'audit sont en lecture seule et ne peuvent être ni modifiées ni supprimées.",
    search_placeholder: "Par utilisateur, action, ID d'événement, IP …",
    date_placeholder: "JJ.MM.AAAA",
    filter_area: "Domaine", filter_action: "Action", filter_actor: "Utilisateur", filter_severity: "Pertinence sécurité",
    filter_from: "Du", filter_to: "Au", filter_security_only: "Pertinents pour la sécurité seulement",
    col_time: "Date & heure", col_actor: "Utilisateur & rôle", col_area: "Domaine", col_action: "Action",
    col_target: "Concerné", col_status: "Statut", col_severity: "Niveau", col_security: "Sécurité",
    col_event: "ID d'événement", col_ip: "Adresse IP", col_session: "Session",
    detail_title: "Détail d'audit", no_results: "Aucune entrée pour ces filtres.",
    showing: "entrées", page_of: "Page {page} sur {pages}", prev: "Précédent", next: "Suivant",
    security_yes: "pertinent pour la sécurité", security_no: "normal",
    severity: { info: "Info", warning: "Avertissement", critical: "Critique" },
    area_label: {
      auth: "Authentification", members: "Membres", reviews: "Vérifications de profil",
      activities: "Activités", reports: "Signalements", groups: "Groupes",
      member_app: "App membre", system: "Système", overview: "Aperçu & tâches", organizations: "Organisations",
      support: "Support", content: "Contenus", notifications: "Notifications", pilot: "Pilote & évaluation",
    },
    status_label: {
      ok: "Réussi", failed: "Échoué", denied: "Refusé", approved: "Approuvé",
      rejected: "Refusé", in_progress: "En traitement", resolved: "Résolu", open: "Ouvert", requested: "Demandé",
    },
    actions: {
      "login.success": "Connexion réussie", "login.2fa_failed": "Échec 2FA",
      "logout": "Déconnexion", "2fa.enrolled": "2FA configurée",
      "access_pass.viewed": "Access Pass consulté", "access_pass.denied": "Access Pass refusé",
      "access_pass.requested": "Access Pass demandé", "access_pass.consent_simulated": "Consentement simulé",
      "review.approved": "Profil approuvé", "review.rejected": "Profil refusé",
      "activity.approved": "Activité approuvée", "activity.rejected": "Activité refusée",
      "report.in_progress": "Signalement en cours", "report.resolved": "Signalement résolu", "report.opened": "Signalement ouvert",
      "member.login.success": "Membre connecté", "member.logout": "Membre déconnecté",
      "member.activity.joined": "Activité rejointe", "member.activity.left": "Activité quittée",
      "member.group.joined": "Groupe rejoint",
    },
  },
  member: {
    app_name: "Visibilis Life", tagline: "Communauté, amitiés et participation.",
    nav: { start: "Accueil", activities: "Activités", groups: "Cercles & Groupes", messages: "Messages", profile: "Mon profil" },
    login: {
      title: "Bon retour", subtitle: "Connecte-toi à ton app membre.",
      email: "Adresse e-mail", password: "Mot de passe", submit: "Se connecter",
      demo_hint: "Accès démo (preview)", show_password: "Afficher le mot de passe", hide_password: "Masquer le mot de passe",
      no_dating: "Visibilis Life n'est pas une plateforme de rencontres – il s'agit d'amitiés, d'intérêts et de participation.",
      preview_badge: "PREVIEW – aucune donnée réelle",
    },
    start: {
      greeting: "Bonjour {name}", intro: "Ravi de te voir. Voici ce qui se passe.",
      announcements: "Actualités", upcoming: "Activités à venir", suggested_groups: "Cercles suggérés",
      empty: "Rien de nouveau pour l'instant.",
    },
    activities: {
      title: "Activités", subtitle: "Des activités sûres et partagées près de chez toi.",
      join: "Participer", joined: "Inscrit", leave: "Se désinscrire",
      participants: "Participants", capacity: "Places", when: "Quand", where: "Où",
      all: "Toutes", empty: "Aucune activité trouvée.",
      joined_toast: "Tu participes maintenant.", left_toast: "Tu t'es désinscrit.",
    },
    groups: {
      title: "Cercles & Groupes", subtitle: "Trouve des communautés aux intérêts communs.",
      join: "Rejoindre", joined: "Rejoint", leave: "Quitter", members: "membres", empty: "Aucun groupe trouvé.",
      joined_toast: "Tu as rejoint le groupe.", left_toast: "Tu as quitté le groupe.",
    },
    messages: {
      title: "Messages", subtitle: "Échanges bienveillants au sein de la communauté.",
      empty: "Aucune conversation.", placeholder: "Écrire un message …", send: "Envoyer",
      community_note: "Merci de rester bienveillant et respectueux.", select_hint: "Choisis une conversation à gauche.",
    },
    profile: {
      title: "Mon profil", edit: "Modifier", save: "Enregistrer", cancel: "Annuler",
      bio: "À propos de moi", bio_placeholder: "Parle un peu de toi …",
      interests: "Intérêts", languages: "Langues", city: "Ville",
      stat_activities: "Activités", stat_groups: "Groupes",
      access_pass: "Access Pass", pass_number: "Numéro de pass", valid_until: "Valable jusqu'au", no_pass: "Aucun Access Pass enregistré.",
      logout: "Se déconnecter", saved_toast: "Profil enregistré.",
      sections: "Paramètres & aide",
      security: "Sécurité", security_2fa: "Authentification à deux facteurs",
      security_2fa_off: "Non activée", security_2fa_on: "Activée",
      security_2fa_note: "Optionnelle dans cette preview. L'activation ultérieure est déjà prête.",
      help: "Aide", help_body: "Des questions ? Notre équipe est là pour t'aider.",
      help_topics: "Sujets fréquents : activités, groupes, sécurité, compte.",
      accessibility: "Accessibilité", high_contrast: "Contraste élevé", large_text: "Grand texte",
      reduce_motion: "Réduire les animations", accessibility_note: "Réglages pour une meilleure lisibilité et utilisation.",
      account: "Compte", account_email: "E-mail", account_note: "Compte démo – aucune donnée réelle, aucun e-mail réel.",
      notifications: "Notifications",
    },
    categories: {
      soziales: "Social", sport: "Sport", kultur: "Culture", bildung: "Éducation",
      freizeit: "Loisirs", regional: "Régional",
    },
  },
};

const it = {
  app: { name: "Visibilis Control OS", env_production: "PROD", env_preview: "ANTEPRIMA", env_test: "TEST", env_dev: "DEV", env_unknown: "Ambiente sconosciuto" },
  nav: {
    overview: "Panoramica", both_apps: "App e gestione", members: "Membri", reviews: "Verifiche profilo",
    activities: "Attività", groups: "Cerchie e Gruppi", reports: "Segnalazioni e Sicurezza",
    organizations: "Organizzazioni", support: "Supporto", content: "Contenuti e Approvazioni",
    notifications: "Notifiche", pilot: "Pilota e Analisi", audit: "Registro di audit",
    system: "Stato del sistema", settings: "Impostazioni", tasks: "I miei compiti", team: "Team e diritti", help: "Aiuto",
  },
  common: {
    search: "Cerca", filter: "Filtro", all: "Tutti", status: "Stato", actions: "Azioni",
    approve: "Approva", reject: "Rifiuta", details: "Dettagli", logout: "Esci",
    role: "Ruolo", language: "Lingua", loading: "Caricamento …", no_data: "Nessuna voce.",
    open_menu: "Apri menu", skip_to_content: "Vai al contenuto", in_preparation: "In preparazione",
    mark_in_progress: "In lavorazione", mark_resolved: "Segna risolto", view_all: "Mostra tutto",
    reset: "Reimposta", back: "Indietro", save: "Salva", cancel: "Annulla", close: "Chiudi",
  },
  labels: {
    aktiv: "attivo", ausstehend: "in attesa", gesperrt: "bloccato", offen: "aperto",
    genehmigt: "approvato", abgelehnt: "rifiutato", freigegeben: "pubblicato",
    "in Bearbeitung": "in lavorazione", "gelöst": "risolto", verifiziert: "verificato",
    kritisch: "critico", mittel: "medio", niedrig: "basso", ruhend: "inattivo",
  },
  login: {
    title: "Accesso", subtitle: "Accesso protetto per i membri autorizzati.",
    email: "Indirizzo e-mail", password: "Password", submit: "Continua",
    twofa_title: "Autenticazione a due fattori",
    twofa_subtitle: "Inserisci il codice a 6 cifre dalla tua app.",
    twofa_submit: "Accedi", back: "Indietro",
    no_public: "Nessuna registrazione pubblica. Solo team interno.",
    preview_hint: "Nota preview: codice demo attuale", preview_fill: "Usa il codice",
    error_credentials: "E-mail o password non corretti.",
    setup_title: "Configura l'autenticazione a due fattori",
    setup_subtitle: "Scansiona il codice QR con un'app di autenticazione (es. Google Authenticator), poi inserisci il codice a 6 cifre mostrato.",
    setup_secret_label: "Chiave manuale (se non puoi scansionare il QR)",
    setup_scan_hint: "Scansiona il codice QR con l'app", setup_confirm: "Completa la configurazione",
    lost_authenticator: "Authenticator smarrito?",
    recover_title: "Accedi con un codice di recupero",
    recover_subtitle: "Inserisci uno dei tuoi codici di recupero monouso. Poi configurerai un nuovo authenticator.",
    recover_code_label: "Codice di recupero",
    recover_submit: "Continua alla riconfigurazione",
    recover_no_codes: "Nessun codice di recupero? I membri del team contattano il Super Admin, che può avviare «Riconfigura 2FA» nel team. Per il Super Admin vale la procedura operatore documentata. Al prossimo accesso compare poi un nuovo codice QR.",
    setup_incomplete: "La riconfigurazione del tuo authenticator non è ancora completata. Con «Authenticator smarrito?» e lo stesso codice di recupero ottieni un nuovo codice QR.",
    resume_setup: "Mostra di nuovo il codice QR",
    resume_setup_hint: "La configurazione 2FA non è ancora completata. Finché la sessione di configurazione è valida (5 minuti), puoi mostrare di nuovo il codice QR.",
    setup_expired: "Accedi di nuovo.",
    mail_recovery: {
      title: "Senza codice di recupero",
      loading: "Caricamento dello stato",
      intro: "Puoi richiedere un recupero via e-mail. È una richiesta, non uno sblocco immediato: confermi il link nell'e-mail, poi vale un periodo di attesa di {hours} ore ed è necessaria un'approvazione indipendente. Solo dopo, al nuovo accesso, compare un nuovo codice QR.",
      request: "Richiedi il recupero via e-mail",
      mail_missing: "L'invio delle e-mail non è ancora configurato. Per questo al momento non è possibile fare una richiesta.",
      mail_handed_over: "L'e-mail è stata consegnata al servizio di invio. Non possiamo vedere se arriva. Controlla anche la cartella spam.",
      email_open: "Conferma il link nell'e-mail entro il {time}. Dopo la richiesta scade.",
      warning_pending: "La conferma è in elaborazione: l'e-mail di avviso viene consegnata al servizio di invio. Il periodo di attesa inizia solo dopo.",
      waiting: "Il periodo di attesa dura fino al {time}.",
      waiting_done: "Il periodo di attesa è terminato.",
      approval_super_admin: "L'approvazione del Super Admin è ancora in sospeso.",
      approval_operator: "L'approvazione tramite la procedura operatore è ancora in sospeso.",
      approved: "L'approvazione è stata concessa.",
      operator_missing: "Bloccato: l'ancora di fiducia dell'operatore non è configurata. La richiesta resta bloccata finché l'operatore non esegue questo passo.",
      operator_step: "Passo operatore: in produzione impostare SUPER_ADMIN_RECOVERY_TOKEN nel Secret Store e ripubblicare. Poi approvare la richiesta {id} con POST /api/internal/recovery/2fa-email-request/approve (header X-Recovery-Token). Vedi il runbook.",
      ready: "Tutte le condizioni sono soddisfatte. Ora puoi configurare un nuovo authenticator.",
      complete: "Configura un nuovo codice QR",
      cancel: "Annulla la richiesta",
      cancelled: "La richiesta è stata annullata.",
      expires: "La richiesta scade al più tardi il {time}.",
      closed: {
        abgeschlossen: "La tua ultima richiesta è conclusa.",
        abgebrochen: "La tua ultima richiesta è stata annullata.",
        abgelehnt: "La tua ultima richiesta è stata respinta.",
        abgelaufen: "La tua ultima richiesta è scaduta.",
        versand_fehlgeschlagen: "Per la tua ultima richiesta non è stato possibile consegnare l'e-mail al servizio di invio. Non è stato attivato nulla.",
        warnung_fehlgeschlagen: "Per la tua ultima richiesta non è stato possibile consegnare l'e-mail di avviso. La richiesta è stata chiusa, non è stato attivato nulla.",
        "ungültig": "La tua ultima richiesta non è più valida perché nel frattempo l'account è stato modificato.",
      },
      link_title: "Recupero 2FA",
      link_confirm_intro: "Conferma qui la tua richiesta di recupero dell'accesso a due fattori. Poi inizia il periodo di attesa di 24 ore.",
      link_cancel_intro: "Annulla qui la richiesta di recupero. Vale subito.",
      link_confirm: "Conferma la richiesta",
      link_cancel: "Annulla subito la richiesta",
      link_invalid: "Questo link non è valido o è scaduto.",
      link_confirmed: "Richiesta confermata. Il periodo di attesa dura fino al {time}.",
      link_next_super_admin: "Poi il Super Admin deve approvare la richiesta. In seguito accedi di nuovo e scegli «Authenticator smarrito?».",
      link_next_operator: "Poi è necessaria un'approvazione tramite la procedura operatore. In seguito accedi di nuovo e scegli «Authenticator smarrito?».",
      link_warning_sent: "Un'e-mail di avviso con link di annullamento è stata consegnata al servizio di invio.",
      link_warning_failed: "Non è stato possibile consegnare l'e-mail di avviso al servizio di invio. La richiesta continua; puoi annullarla all'accesso.",
      link_cancelled: "La richiesta è annullata. Se non l'hai fatta tu, cambia la password.",
      admin_title: "Richieste di recupero senza codice",
      admin_disabled: "Il recupero via e-mail non è attivato.",
      admin_empty: "Nessuna richiesta aperta.",
      admin_meta: "Richiesta {created} · e-mail confermata {confirmed} · attesa fino al {wait}",
      admin_approve: "Approva",
      admin_approve_info: "Approva solo se hai verificato personalmente l'identità della persona. Il periodo di attesa non viene ridotto.",
      admin_confirm_email: "Inserisci l'e-mail per confermare ({email})",
      admin_reason: "Motivazione",
      admin_approved: "Approvazione concessa.",
      admin_reject: "Respingi",
      admin_rejected: "Richiesta respinta.",
      admin_wait_email: "Approvazione possibile solo dopo che la persona ha confermato il link e-mail.",
    },
    codes_title: "I tuoi codici di recupero",
    codes_subtitle: "Conserva questi codici in un luogo sicuro (es. un gestore di password). Vengono mostrati solo UNA volta e ogni codice funziona una sola volta.",
    codes_ack: "Ho salvato questi codici in modo sicuro.",
    codes_continue: "Vai alla dashboard",
    codes_copy: "Copia codici",
    codes_copied: "Copiato",
    control_os_title: "Visibilis Control OS",
    tagline: "Lo spazio di lavoro sicuro per verifica, moderazione e gestione della piattaforma.",
    function_line: "Verificare i membri · Approvare le attività · Gestire la sicurezza",
    brand_team: "Solo team interno", brand_admin: "Martin = unico Super Admin", brand_2fa: "Protetto da 2FA",
    card_title: "Accesso sicuro", card_subtitle: "Solo per Martin e i membri autorizzati del team Visibilis.",
    show_password: "Mostra password", hide_password: "Nascondi password",
    next_hint: "Segue la conferma 2FA con l'app di autenticazione.",
    status_internal: "Accesso interno protetto", status_no_public: "Nessuna registrazione pubblica",
    preview_badge: "PREVIEW – nessun dato di produzione",
    footer_rights: "© 2026 Visibilis.Life – Tutti i diritti riservati.",
    footer_privacy: "Privacy", footer_imprint: "Note legali", footer_support: "Supporto",
  },
  overview: {
    title: "Panoramica", subtitle: "Stato attuale del nucleo condiviso di Visibilis.",
    kpi_members: "Membri totali", kpi_reviews: "Verifiche aperte",
    kpi_reports: "Segnalazioni aperte", kpi_activities: "Attività attive",
    recent_activity: "Attività recenti (registro di audit)", pending_reviews: "Verifiche in attesa",
    critical_reports: "Segnalazioni critiche", none_critical: "Nessuna segnalazione critica. Tutto sicuro.",
  },
  members: {
    title: "Membri", subtitle: "Dati dei membri condivisi dall'app.",
    col_name: "Nome", col_city: "Città", col_org: "Organizzazione", col_languages: "Lingue",
    col_verification: "Verifica", col_joined: "Adesione",
    search_placeholder: "Cerca per nome …", org_all: "Tutte le organizzazioni",
    col_accesspass: "Access Pass", view_pass: "Mostra",
  },
  reviews: {
    title: "Verifiche profilo", subtitle: "Approva o rifiuta profili nuovi e modificati.",
    col_member: "Membro", col_type: "Tipo", col_note: "Nota", col_submitted: "Inviato",
    approved_toast: "Profilo approvato e membro verificato.", rejected_toast: "Profilo rifiutato.",
  },
  activities: {
    title: "Attività", subtitle: "Approva le attività – poi visibili nell'app membri.",
    col_title: "Titolo", col_category: "Categoria", col_location: "Luogo", col_date: "Data",
    col_participants: "Partecipanti", approved_toast: "Attività pubblicata.", rejected_toast: "Attività rifiutata.",
  },
  groups: {
    title: "Cerchie e Gruppi", subtitle: "Comunità all'interno di Visibilis Life.", members_count: "membri",
  },
  reports: {
    title: "Segnalazioni e Sicurezza", subtitle: "Moderazione sicura – visibile solo alle persone autorizzate.",
    col_title: "Segnalazione", col_context: "Contesto", col_severity: "Gravità", col_reporter: "Segnalante",
    in_progress_toast: "Segnalazione contrassegnata in lavorazione.", resolved_toast: "Segnalazione risolta.",
  },
  pilot: {
    title: "Pilota e Analisi", subtitle: "Indicatori ed evoluzione della fase pilota.",
    signups: "Iscrizioni al mese", participation: "Partecipazione per categoria",
    months: ["gen", "feb", "mar", "apr", "mag", "giu"],
    kpi_verified: "Membri verificati", kpi_activities: "Attività attive",
    kpi_reviews: "Verifiche completate", kpi_satisfaction: "Soddisfazione",
  },
  placeholder: {
    subtitle: "Questa sezione sarà attivata in una fase successiva.",
    body: "Il nucleo sicuro condiviso, i ruoli e il registro di audit sono già pronti. Questa interfaccia seguirà dopo la tua approvazione.",
  },
  accesspass: {
    title: "Access Pass", consent_granted: "Consenso concesso dalla persona interessata",
    locked_title: "Accesso bloccato",
    locked_body: "I dati dell'Access Pass sono visibili solo dopo il consenso esplicito della persona interessata.",
    request: "Richiedi consenso", requested_toast: "Il consenso è stato richiesto alla persona.",
    simulate: "Simula consenso (solo preview)", simulated_toast: "Consenso simulato – l'Access Pass ora è visibile.",
    field_number: "Numero pass", field_category: "Categoria", field_valid: "Valido fino al",
    field_benefits: "Agevolazioni", field_issued: "Rilasciato da",
  },
  noaccess: { title: "Nessun accesso", body: "Il tuo ruolo non ha l'autorizzazione per questa sezione." },
  categories: { soziales: "Sociale", sport: "Sport", kultur: "Cultura", bildung: "Formazione", freizeit: "Tempo libero", regional: "Regionale" },
  audit: {
    title: "Registro di audit", subtitle: "Registro eventi completo e immutabile – riservato esclusivamente al Super Admin.",
    readonly_note: "Le voci di audit sono di sola lettura e non possono essere modificate o eliminate.",
    search_placeholder: "Per utente, azione, ID evento, IP …",
    date_placeholder: "GG.MM.AAAA",
    filter_area: "Ambito", filter_action: "Azione", filter_actor: "Utente", filter_severity: "Rilevanza sicurezza",
    filter_from: "Dal", filter_to: "Al", filter_security_only: "Solo rilevanti per la sicurezza",
    col_time: "Data e ora", col_actor: "Utente e ruolo", col_area: "Ambito", col_action: "Azione",
    col_target: "Interessato", col_status: "Stato", col_severity: "Livello", col_security: "Sicurezza",
    col_event: "ID evento", col_ip: "Indirizzo IP", col_session: "Sessione",
    detail_title: "Dettaglio audit", no_results: "Nessuna voce per questi filtri.",
    showing: "voci", page_of: "Pagina {page} di {pages}", prev: "Precedente", next: "Successivo",
    security_yes: "rilevante per la sicurezza", security_no: "normale",
    severity: { info: "Info", warning: "Avviso", critical: "Critico" },
    area_label: {
      auth: "Autenticazione", members: "Membri", reviews: "Verifiche profilo",
      activities: "Attività", reports: "Segnalazioni", groups: "Gruppi",
      member_app: "App membri", system: "Sistema", overview: "Panoramica & compiti", organizations: "Organizzazioni",
      support: "Supporto", content: "Contenuti", notifications: "Notifiche", pilot: "Pilota & valutazione",
    },
    status_label: {
      ok: "Riuscito", failed: "Fallito", denied: "Negato", approved: "Approvato",
      rejected: "Rifiutato", in_progress: "In lavorazione", resolved: "Risolto", open: "Aperto", requested: "Richiesto",
    },
    actions: {
      "login.success": "Accesso riuscito", "login.2fa_failed": "2FA fallita",
      "logout": "Disconnessione", "2fa.enrolled": "2FA configurata",
      "access_pass.viewed": "Access Pass visualizzato", "access_pass.denied": "Access Pass negato",
      "access_pass.requested": "Access Pass richiesto", "access_pass.consent_simulated": "Consenso simulato",
      "review.approved": "Profilo approvato", "review.rejected": "Profilo rifiutato",
      "activity.approved": "Attività approvata", "activity.rejected": "Attività rifiutata",
      "report.in_progress": "Segnalazione in lavorazione", "report.resolved": "Segnalazione risolta", "report.opened": "Segnalazione aperta",
      "member.login.success": "Membro connesso", "member.logout": "Membro disconnesso",
      "member.activity.joined": "Attività aggiunta", "member.activity.left": "Attività abbandonata",
      "member.group.joined": "Gruppo aggiunto",
    },
  },
  member: {
    app_name: "Visibilis Life", tagline: "Comunità, amicizie e partecipazione.",
    nav: { start: "Inizio", activities: "Attività", groups: "Cerchie e Gruppi", messages: "Messaggi", profile: "Il mio profilo" },
    login: {
      title: "Bentornato", subtitle: "Accedi alla tua app membri.",
      email: "Indirizzo e-mail", password: "Password", submit: "Accedi",
      demo_hint: "Accesso demo (preview)", show_password: "Mostra password", hide_password: "Nascondi password",
      no_dating: "Visibilis Life non è una piattaforma di incontri – si tratta di amicizie, interessi e partecipazione.",
      preview_badge: "PREVIEW – nessun dato reale",
    },
    start: {
      greeting: "Ciao {name}", intro: "Felici che tu ci sia. Ecco cosa sta succedendo.",
      announcements: "Novità", upcoming: "Prossime attività", suggested_groups: "Cerchie suggerite",
      empty: "Nessuna novità al momento.",
    },
    activities: {
      title: "Attività", subtitle: "Attività sicure e condivise vicino a te.",
      join: "Partecipa", joined: "Iscritto", leave: "Annulla iscrizione",
      participants: "Partecipanti", capacity: "Posti", when: "Quando", where: "Dove",
      all: "Tutte", empty: "Nessuna attività trovata.",
      joined_toast: "Ora partecipi.", left_toast: "Hai annullato l'iscrizione.",
    },
    groups: {
      title: "Cerchie e Gruppi", subtitle: "Trova comunità con interessi comuni.",
      join: "Unisciti", joined: "Iscritto", leave: "Esci", members: "membri", empty: "Nessun gruppo trovato.",
      joined_toast: "Ti sei unito al gruppo.", left_toast: "Hai lasciato il gruppo.",
    },
    messages: {
      title: "Messaggi", subtitle: "Scambio amichevole nella comunità.",
      empty: "Nessuna conversazione.", placeholder: "Scrivi un messaggio …", send: "Invia",
      community_note: "Per favore, resta gentile e rispettoso.", select_hint: "Scegli una conversazione a sinistra.",
    },
    profile: {
      title: "Il mio profilo", edit: "Modifica", save: "Salva", cancel: "Annulla",
      bio: "Chi sono", bio_placeholder: "Racconta qualcosa di te …",
      interests: "Interessi", languages: "Lingue", city: "Città",
      stat_activities: "Attività", stat_groups: "Gruppi",
      access_pass: "Access Pass", pass_number: "Numero pass", valid_until: "Valido fino al", no_pass: "Nessun Access Pass registrato.",
      logout: "Esci", saved_toast: "Profilo salvato.",
      sections: "Impostazioni e aiuto",
      security: "Sicurezza", security_2fa: "Autenticazione a due fattori",
      security_2fa_off: "Non attivata", security_2fa_on: "Attivata",
      security_2fa_note: "Opzionale in questa preview. L'attivazione futura è già predisposta.",
      help: "Aiuto", help_body: "Domande? Il nostro team è felice di aiutarti.",
      help_topics: "Argomenti comuni: attività, gruppi, sicurezza, account.",
      accessibility: "Accessibilità", high_contrast: "Contrasto elevato", large_text: "Testo grande",
      reduce_motion: "Riduci animazioni", accessibility_note: "Impostazioni per una migliore leggibilità e utilizzo.",
      account: "Account", account_email: "E-mail", account_note: "Account demo – nessun dato reale, nessuna e-mail reale.",
      notifications: "Notifiche",
    },
    categories: {
      soziales: "Sociale", sport: "Sport", kultur: "Cultura", bildung: "Formazione",
      freizeit: "Tempo libero", regional: "Regionale",
    },
  },
};

export const translations = { de, en, fr, it };
export const LANGUAGES = [
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
  { code: "it", label: "Italiano" },
  { code: "en", label: "English" },
];
